export const headerCustomerListData = [
    "Profile ID",
    "Biometric ID",
    "Faceprint",
    "Họ tên",
    "Kênh khách hàng",
    "Ngày đăng ký",
    "Thời gian",
]